import React from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../actions/modalActions';
import CompareCard from './compareCard/compareCard';
import RatingInfoCard from './ratingInfoCard/ratingInfoCard';
import AddFiltersMenu from './addFiltersMenu/addFiltersMenu';
import DietDecideInfoCard from './dietDecideInfoCard/dietDecideInfoCard';
import './modal.scss';

const Modal = ({ modal, closeModal }) => {
    
    if (!modal) {
        return null;
    }

    let component;
    switch (modal) {
        case 'comparison':
            component = <CompareCard />;
            break;
        case 'ratingInfo':
            component = <RatingInfoCard />;
            break;
        case 'addMoreFilters':
            component = <AddFiltersMenu />;
            break;
        case 'dietDecide':
            component = <DietDecideInfoCard />;
            break;
        default:
            return null;
    }


    return (
        <div className="modal-background" onClick={closeModal}>
            <div className="modal-child" onClick={e => e.stopPropagation()}>
                {component}
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        modal: state.ui.modal
    };
};

const mapDispatchToProps = dispatch => {
    return {
        closeModal: () => dispatch(closeModal())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Modal);